import React from 'react';

const GraduationCapIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.5}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22 9.429L12 4 2 9.429l10 5.428 10-5.428z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 10.114v4.215a1 1 0 00.5.866l7 4.041a1 1 0 001 0l7-4.041a1 1 0 00.5-.866v-4.215"
    />
    <path strokeLinecap="round" strokeLinejoin="round" d="M20 10v6" />
  </svg>
);

export default GraduationCapIcon;
